// extracted by mini-css-extract-plugin
export default {"root":"p4kL2TpKHPF2ixk0QE_W","header":"sdo3HPLVphcL75DNSYK8","message":"cGsoI4212fRTGMppcjxk","placeHolderShimmer":"_PEm6M6JvCMWitXaK0kD"};